export const problemDomainPages = {
  domainSelectionPage: 'domainSelectionPage',
  subscriptionSelectionPage: 'subscriptionSelectionPage',
  scanningPage: 'scanningPage',
  detectedFaultPage: 'detectedFaultPage',
  unidentifiedFaultPage: 'unidentifiedFaultPage',
};
